const outlineStyle = {
  name: "outline-style",
  path: "/outline-style",
  title: "outline-style",
  description: "Utilities for controlling the style of an element's borders.",
  value: {
    'outline-style': {
      'outline-style-solid': 'solid;',
      'outline-style-dashed': 'dashed;',
      'outline-style-dotted': 'dotted;',
      'outline-style-double': 'double;',
      'outline-style-hidden': 'hidden;',
      'outline-style-none': 'none;',
    }
  },
  exampleData: [
    {
      example: {
        code: `<button class="outline-2 outline-style-solid outline-offset-2">Button A</button>
<button class="outline-2 outline-style-dashed outline-offset-2">Button B</button>
<button class="outline-2 outline-style-dotted outline-offset-2">Button C</button>
<button class="outline-4 outline-style-double outline-offset-2">Button D</button>
<button class="outline-2 focus:outline-style-hidden outline-offset-2">Button E</button>`
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-style-solid</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-style-dashed</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-style-dotted</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-style-double</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-style-hidden</code>, and <code class="text-color-gray-800 dark:text-color-white font-semibold">outline-style-none</code> to set the outline style of an element.
      </p>
      <div class="flex justify-center gap-6 items-center text-sm flex-wrap text-color-gray-500">
          <button class="outline-2 outline-style-solid outline-offset-2 outline-color-red-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button A</button>
          <button class="outline-2 outline-style-dashed outline-offset-2 outline-color-blue-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button B</button>
          <button class="outline-2 outline-style-dotted outline-offset-2 outline-color-orange-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button C</button>
          <button class="outline-4 outline-style-double outline-offset-2 outline-color-green-500 rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button D</button>
          <button class="outline-2 focus:outline-style-hidden outline-offset-2 outline-color-[#ffc107] rounded-md bg-color-white px-4 py-2 text-sm font-semibold text-color-gray-600 border border-color-gray-200">Button E</button>
      </div>
      `
    }
  ]
};

export default outlineStyle;

<div class="sr-only flex justify-center outline-style-double focus:outline-style-hidden gap-6 items-center font-mono text-sm font-bold flex-wrap">
<div class="outline-style-solid border-2 divide-x-2 outline-color-green-500 divide-y-2 divide-style-solid divide-style-dashed border-color-blue-500 p-4 h-20">border-style-solid</div>
        <div class="outline-style-dashed border-2 border-color-blue-500 p-4 h-20">border-style-dashed</div>
        <div class="outline-style-dotted border-2 border-color-blue-500 p-4 h-20">border-style-dotted</div>
        <div class="outline-style-double border-2 border-color-blue-500 p-4 h-20">border-style-double</div>
        <div class="outline-style-hidden border-2 border-color-blue-500 p-4 h-20">border-style-hidden</div>
        <div class="outline-style-none border-2 border-color-blue-500 p-4 h-20">border-style-none</div>
</div>